import iconStaircase from "../images/iconStaircase.png";
import iconCorrect from "../images/iconCorrect.png";
import { packageDetails, trainingDetails } from "../data";
import Button from "./Button";

export default function Pricing() {
  return (
    <section
      className="mt-20 py-16 w-[90%] mx-auto bg-orange-opacity  px-8  "
      id="pricing"
    >
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-4 items-center">
        <div>
          <h2 className="text-lg md:text-3xl font-black text-medium-black mb-10 text-center lg:text-start">
            Find the package that suits you the best
          </h2>
          <ul className="font-black  flex flex-col gap-4 justify-center items-center lg:items-start">
            {packageDetails.map((eachDetails, index) => {
              return (
                <li className="flex flex-row gap-4 items-center " key={index}>
                  <img src={iconStaircase} alt="bullet" />
                  <span className="text-light-purple text-lg lg:text-2xl">
                    {" "}
                    {eachDetails}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="bg-white px-5 py-10 rounded-3xl">
          <div className="flex flex-col md:flex-row md:gap-2 gap-10 items-center justify-around">
            <ul className="flex flex-col gap-3">
              {trainingDetails.map((eachData, index) => {
                return (
                  <li className="flex flex-row gap-4 items-center" key={index}>
                    <img src={iconCorrect} alt="bullet" />
                    <span className="font-semibold">{eachData}</span>
                  </li>
                );
              })}
            </ul>

            <div className="">
              <p className="text-5xl font-black text-dark-blue">£260</p>
              <p className="text-light-grey font-bold text-center mb-8">
                per year
              </p>
              <Button color="light-purple">Enroll now</Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
